export default __webpack_public_path__ + "static/media/design.2ba2b681.png";